import type {
	TicketCategoryOption,
	TicketPriorityOption,
	TicketStatusOption,
	TicketTierOption
} from '@/types/ticketing'
import type { SortMap } from '@/utils/sortMethods/types'

const TICKET_STATUS_OPTIONS = {
	OPEN: 'Open',
	CLOSED: 'Closed',
	PENDING_INTERNAL: 'Pending Internal',
	PENDING_EXTERNAL: 'Pending External',
	ACTIVE: 'Active',
	CANCELED: 'Canceled'
} as const

const TICKET_STATUS_SELECT_OPTIONS: TicketStatusOption[] = Object.entries(TICKET_STATUS_OPTIONS).map(([ key, value ]) => ({
	id: key,
	name: value
}))

const TICKET_STATUS_OPTIONS_LIST = [
	{
		id: 1,
		name: TICKET_STATUS_OPTIONS.OPEN,
		value: TICKET_STATUS_OPTIONS.OPEN
	},
	{
		id: 2,
		name: TICKET_STATUS_OPTIONS.CLOSED,
		value: TICKET_STATUS_OPTIONS.CLOSED
	},
	{
		id: 3,
		name: TICKET_STATUS_OPTIONS.PENDING_INTERNAL,
		value: TICKET_STATUS_OPTIONS.PENDING_INTERNAL
	},
	{
		id: 4,
		name: TICKET_STATUS_OPTIONS.PENDING_EXTERNAL,
		value: TICKET_STATUS_OPTIONS.PENDING_EXTERNAL
	},
	{
		id: 5,
		name: TICKET_STATUS_OPTIONS.ACTIVE,
		value: TICKET_STATUS_OPTIONS.ACTIVE
	},
	{
		id: 6,
		name: TICKET_STATUS_OPTIONS.CANCELED,
		value: TICKET_STATUS_OPTIONS.CANCELED
	}
] as const

const TICKET_CATEGORY_OPTIONS = {
	GENERAL: 'General',
	BILLING: 'Billing',
	CONSTRUCTION: 'Construction',
	RECLAMATION: 'Reclamation',
	TECH_SUPPORT: 'Tech Support',
	ACCOUNTING: 'Accounting',
	VOIP: 'VoIP',
	STATIC_IP: 'Static IP'
} as const

const TICKET_CATEGORY_SELECT_OPTIONS: TicketCategoryOption[] = Object.entries(TICKET_CATEGORY_OPTIONS).map(([ key, value ]) => ({
	id: key,
	name: value
}))

const TICKET_PRIORITY_OPTIONS = {
	LOW: 'Low',
	MEDIUM: 'Medium',
	HIGH: 'High'
} as const

const TICKET_PRIORITY_SELECT_OPTIONS: TicketPriorityOption[] = Object.entries(TICKET_PRIORITY_OPTIONS).map(([ key, value ]) => ({
	id: key,
	name: value
}))

const TICKET_TIER_OPTIONS = {
	TIER1: 'Tier 1',
	TIER2: 'Tier 2'
} as const

const TICKET_TIER_SELECT_OPTIONS: TicketTierOption[] = Object.entries(TICKET_TIER_OPTIONS).map(([ key, value ]) => ({
	id: key,
	name: value
}))

const TICKET_STATUS_MAPPING: SortMap = {
	'active': 4,
	'open': 3,
	'pending-internal': 2,
	'pending-external': 1,
	'closed': 0
}

const TICKET_PRIORITY_MAPPING: SortMap = {
	highest: 4,
	high: 3,
	medium: 2,
	low: 1,
	lowest: 0
}

const inProgressStatuses = [
	TICKET_STATUS_OPTIONS.OPEN,
	TICKET_STATUS_OPTIONS.PENDING_EXTERNAL,
	TICKET_STATUS_OPTIONS.PENDING_INTERNAL,
	TICKET_STATUS_OPTIONS.ACTIVE
]

export {
	inProgressStatuses,
	TICKET_CATEGORY_OPTIONS, TICKET_CATEGORY_SELECT_OPTIONS, TICKET_PRIORITY_MAPPING,
	TICKET_PRIORITY_OPTIONS, TICKET_PRIORITY_SELECT_OPTIONS, TICKET_STATUS_MAPPING,
	TICKET_STATUS_OPTIONS,
	TICKET_STATUS_OPTIONS_LIST, TICKET_STATUS_SELECT_OPTIONS, TICKET_TIER_OPTIONS,
	TICKET_TIER_SELECT_OPTIONS
}

